import {logger, UUID} from 'yougile-util'
import {newsCompanyId} from 'yougile-model'
import {Debouncer} from '../../../common/debouncer'
import {Sync} from '../../client/sync'
import {SyncEvents, SyncListenerFilter} from '../../client/sync-events'
import {globals} from '../../extensions/globals-base'
import {ComponentUpdater} from './index'

interface SyncUpdaterOpts {
  filter: SyncListenerFilter
  debounceTime?: number
  companyType?: 'current' | 'profile' | 'news' | 'all-other-companies'
  beforeUpdate?: () => void
}

interface SyncState {
  handlerId: number
  anyHandlerId: UUID
  companyHandlerId: number
  debouncer: Debouncer<unknown>
}

export const SyncUpdater: (opts: SyncUpdaterOpts) => ComponentUpdater =
  opts => {
    return {
      displayName: `Sync`,
      onMount(update: () => void): SyncState {
        const {debounceTime, filter, companyType, beforeUpdate} = opts
        const debouncer = debounceTime ? new Debouncer(debounceTime) : undefined
        const updateFn = () => {
          if (beforeUpdate) {
            beforeUpdate()
          }
          update()
        }
        const up = debouncer
          ? () => debouncer.runButNotOften(updateFn)
          : updateFn

        const state: SyncState = {
          handlerId: undefined,
          anyHandlerId: undefined,
          companyHandlerId: undefined,
          debouncer
        }

        if (companyType === 'current') {
          const listenCompany = () => {
            SyncEvents.removeListener(state.handlerId)
            state.handlerId = SyncEvents.addListener(
              globals.getCompanyId(),
              filter,
              up
            )
          }
          state.companyHandlerId = globals.onCompanyChange(() => {
            up()
            listenCompany()
          })
          listenCompany()
        } else if (companyType === 'profile') {
          state.handlerId = SyncEvents.addListener(Sync.profileId, filter, up)
        } else if (companyType === 'news') {
          state.handlerId = SyncEvents.addListener(newsCompanyId, filter, up)
        } else if (companyType === 'all-other-companies') {
          state.anyHandlerId = SyncEvents.addAnyListener(companyId => {
            if (
              companyId !== globals.getCompanyId() &&
              companyId !== newsCompanyId &&
              companyId !== Sync.profileId
            ) {
              up()
            }
          })
        } else {
          logger.error('Unknown companyType')
        }
        return state
      },
      onUnmount(state: SyncState): void {
        if (state.debouncer) {
          state.debouncer.clear()
        }
        SyncEvents.removeListener(state.handlerId)
        SyncEvents.removeAnyListener(state.anyHandlerId)
        globals.removeCompanyListener(state.companyHandlerId)
      }
    }
  }
